import { useState } from "react";

import { useRootStore } from "store";
import { Button } from "components/button/Button";

import "./UserSettings.scss";

export default function UserSettings () {
const {userInfo} = useRootStore((state) => state.user);

const [resetPassword, setResetPassword] = useState(false);

const {sendActivation} = useRootStore((state) => state.customerServerSettings)

const requestToChangePassword = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if(userInfo){
        sendActivation(userInfo.email);
        setResetPassword(true)
    }
}

const renderResetPassword = () => {
    if (userInfo && userInfo.type.toLowerCase() === "external") {
        let resetText = "";
        if (resetPassword) {
          resetText = "E-post skickat till " + userInfo.email;
        }
  
        return (
          <div>
            <hr />
            <h2>Lösenord</h2>
            <div>
              <div className="info">
                Om du vill ändra ditt lösenord, klicka på Byt lösenord och en länk
                kommer att skickas till din e-post med instruktioner.
              </div>
              {!resetPassword && (
                <Button
                  variant={"secondary outline"}
                  size={"sm"}
                  onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>)=>requestToChangePassword(e)}
                >
                  Byt lösenord
                </Button>
              )}
              {resetText}
            </div>
          </div>
        );
      }
}

const renderInformation = () =>{
    if (userInfo && userInfo.type.toLowerCase() === "external") {
        const name = userInfo.givenName + " " + userInfo.surName;
        return (
          <div>
            <h2>Mina uppgifter</h2>
            <div className="info">
              Här ser du vilka uppgifter som finns inlagda på dig. Du loggar in i
              MittKontor med hjälp av din e-postadress och ditt lösenord. Meddela
              Ludvig &amp; Co om du vill ändra dina uppgifter.
            </div>
            <div className="userInformation">
              <div>
                <span>Namn:</span>
                <span>{name}</span>
              </div>
              <div>
                <span>Personnummer:</span>
                <span>{userInfo.socialSecurityNumber}</span>
              </div>
              <div>
                <span>E-post:</span>
                <span>{userInfo.email}</span>
              </div>
            </div>
          </div>
        );
      }
}


return (
    <div className="informationBox">
    {renderInformation()}
    {renderResetPassword()}
    {userInfo && userInfo.type.toLowerCase() === "internal" && (
      <div>
        <h2>Frånvaromeddelande</h2>
        <div className="ooo">
          <p>
            Detta hanteras numera från Outlook. Sätt ett frånvaromeddelande
            (Out of Office) i Outlook för att använda denna funktionen.
          </p>
          <p>
            Frånvaromeddelande <i>utom</i> organisationen visas för alla,
            både kundanvändare och konsulter.
          </p>
        </div>
      </div>
    )}
  </div>
)
    
}